<template>
  <!--login -->
  <v-app class="auth-box">
    <div class="loader" />
    <div class="px-0 px-sm-2 px-md-4 float-left mt-5">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined v-bind="attrs" v-on="on">
            <img :src="currentLocale.flag" alt="" width="20" class="mr-2" />
            {{ currentLocale.name }}
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item-group>
            <v-list-item
              v-for="locale in locales"
              :key="locale.lang"
              @click="onChangeLanguage(locale.lang)"
              :value="locale.lang"
            >
              <img :src="locale.flag" alt="" width="20" class="mr-2" />
              <v-list-item-content>
                <v-list-item-title>{{ locale.name }}</v-list-item-title>
                <v-list-item-subtitle class="text--secondary">
                  {{ locale.subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-menu>

      <v-btn class="mx-1" icon @click="toggleNightMode">
        <v-icon>mdi-invert-colors</v-icon>
      </v-btn>
    </div>

    <v-main>
      <v-container class="pa-0" fill-height fluid>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-card
              :loading="loading"
              class="login-box rounded-xl"
              color="rgba(255, 255, 255, .4)"
              outlined
            >
              <v-card-actions class="justify-center auth-img-holder">
              </v-card-actions>

              <v-card-text class="text-center px-8 py-5">
                <v-card-title class="text-center">
                  <div class="mx-auto d-flex align-center">
                    <a :href="$terminalads" target="_blank">
                      <v-img
                        max-height="130"
                        max-width="130"
                        src="/media/newLogo.webp"
                      />
                    </a>
                  </div>
                </v-card-title>

                <v-card-title
                  v-if="!forget_password && !registered"
                  class="text-center"
                >
                  <v-btn
                    id="jumpingBtn"
                    class="mx-auto"
                    color="error"
                    depressed
                    @click="
                      (registered = true),
                        (forget = false),
                        (forgetPassword = false),
                        (methodSelected = '')
                    "
                  >
                    {{ $t("login.signup_button") }}
                  </v-btn>
                </v-card-title>

                <v-card-title class="text-center my-2">
                  <span v-if="forget_password" class="mx-auto">{{
                    $t("login.forget_password_title")
                  }}</span>
                  <span v-else-if="registered" class="mx-auto">{{
                    $t("login.register_title")
                  }}</span>
                  <span v-else-if="forgetPassword" class="mx-auto">{{
                    $t("login.forget_password_title")
                  }}</span>
                  <span v-else class="mx-auto">{{
                    $t("login.login_title")
                  }}</span>
                </v-card-title>

                <v-card-title
                  v-if="methodSelected !== ''"
                  class="justify-start px-0"
                >
                  <v-btn color="transparent" small @click="methodSelected = ''">
                    <v-icon class="ml-1" style="transform: rotateY(180deg)"
                      >mdi-keyboard-backspace
                    </v-icon>
                    {{ $t("login.back") }}
                  </v-btn>
                </v-card-title>
                <!--'"-->

                <div v-if="!registered">
                  <v-text-field
                    id="edit_user"
                    v-if="$i18n.locale === 'fa'"
                    v-model="username"
                    :disabled="methodSelected == 'otp' || forget == true"
                    :error-messages="
                      errors.verify.username === undefined
                        ? []
                        : errors.verify.username
                    "
                    append-icon="mdi-account"
                    autofocus
                    dense
                    :label="$t('login.username_label')"
                    outlined
                    type="text"
                  />

                  <div class="mb-5 pb-2" v-if="$i18n.locale !== 'fa'">
                    <!-- <div class="mb-5 pb-2"> -->
                    <TelInput
                      :error-messages="
                        errors.verify.username === undefined
                          ? []
                          : errors.verify.username
                      "
                      :disabled="methodSelected == 'otp' || forget == true"
                      v-model="username"
                    />
                  </div>

                  <ForgetPassword
                    v-if="forget"
                    :code="code"
                    :username="username"
                    @passChanged="
                      methodSelected = '';
                      forget = false;
                      forget_password = false;
                    "
                  />

                  <num-keypad
                    v-if="methodSelected === 'otp'"
                    v-model="numberCode"
                    :loading="loading"
                  />

                  <v-btn
                    v-if="methodSelected == 'otp' && forgetPassword === false"
                    :disabled="timeSms > 0"
                    :style="timeSms > 0 ? 'color: #7e7e7e;' : 'color: #E738FF;'"
                    min-width="150"
                    outlined
                    @click="
                      () => {
                        this.resend = true;
                        this.verify();
                      }
                    "
                  >
                    <span>{{ $t("login.otp_resend_button") }}</span>

                    <span v-if="timerSms > 0" id="min">{{ timeSms }}</span>
                  </v-btn>

                  <v-btn
                    v-if="
                      methodSelected == 'otp' &&
                      !forget_password &&
                      forgetPassword
                    "
                    :disabled="time > 0"
                    :style="time > 0 ? 'color: #7e7e7e;' : ''"
                    height="48"
                    min-width="150"
                    outlined
                    small
                    @click="forgetPass"
                  >
                    <span>{{ $t("login.otp_resend_button") }}</span>
                    <span>{{ time }}</span>
                  </v-btn>

                  <v-text-field
                    v-if="
                      !forget_password && !verified && methodSelected == 'pass'
                    "
                    id="edit_pass"
                    v-model="loginpass"
                    :error-messages="
                      errors.verify.password === undefined
                        ? []
                        : errors.verify.password
                    "
                    :rules="[rules.required, rules.min]"
                    append-icon="mdi-lock"
                    autofocus
                    dense
                    :hint="$t('login.password_hint')"
                    :label="$t('login.password_label')"
                    outlined
                    type="password"
                  />

                  <button
                    v-if="
                      !forget_password && !verified && methodSelected == 'pass'
                    "
                    :disabled="time > 0 || loading"
                    class="btn btn-link"
                    @click="forgetPass"
                  >
                    {{ $t("login.forgot_password_link") }} {{ time }}
                  </button>

                  <v-alert
                    v-if="forget_password && forget_password_send"
                    icon="mdi-check"
                    prominent
                    type="success"
                  >
                    {{ $t("text.reset_password_mail_sent") }}
                  </v-alert>

                  <v-btn
                    v-if="
                      !forget_password &&
                      methodSelected === 'pass' &&
                      forgetPassword === false
                    "
                    id="login_submit"
                    :loading="loading"
                    color="primary"
                    min-width="110"
                    @click="login"
                  >
                    <v-icon>mdi-chevron-right</v-icon>
                    {{
                      forget_password
                        ? $t("login.change_password")
                        : $t("login.login_button")
                    }}
                  </v-btn>
                </div>

                <RegisterForm
                  v-if="registered"
                  :errors="errors"
                  :invited="invited"
                  :loading="loading"
                  :initial-phone="phone"
                  @register="register"
                  @show-login="registered = false"
                  @error="(msg) => $toast.error(msg)"
                />
              </v-card-text>

              <v-divider />

              <v-card-actions class="justify-center">
                <v-container grid-list-md text-xs-center>
                  <v-row justify="center" row wrap>
                    <v-col>
                      <v-btn
                        v-if="
                          !registered &&
                          !forget_password &&
                          methodSelected == ''
                        "
                        id="login_google"
                        :loading="loadingGoogle"
                        block
                        class="white--text"
                        color="pink"
                        @click="goToGoogle"
                      >
                        <v-icon>mdi-google</v-icon>
                        {{ $t("login.login_with_google") }}
                      </v-btn>
                    </v-col>
                    <!--v-if="$i18n.locale === 'fa'"-->
                    <v-col>
                      <v-btn
                        v-if="
                          !registered &&
                          !forget_password &&
                          methodSelected == ''
                        "
                        id="login_sms"
                        :disabled="timerSms > 0"
                        :loading="loadingotp"
                        block
                        class="white--text"
                        color="purple darken-2"
                        @click="verify()"
                      >
                        <v-icon>mdi-cellphone-message</v-icon>
                        <span>{{
                          methodSelected == "otp" &&
                          timerSms !== null &&
                          timerSms > 0
                            ? $t("login.otp_resend_button")
                            : $t("login.login_with_sms")
                        }}</span>
                        {{ timeSms > 0 ? timeSms : "" }}
                      </v-btn>
                    </v-col>

                    <v-col>
                      <v-btn
                        v-if="
                          !registered &&
                          !forget_password &&
                          methodSelected == ''
                        "
                        id="login_pass"
                        block
                        class="white--text"
                        color="primary"
                        @click="
                          (methodSelected = 'pass'),
                            (forget = false),
                            (forgetPassword = false)
                        "
                      >
                        <v-icon class="mr-1">mdi-lock</v-icon>
                        {{
                          forget_password
                            ? $t("login.change_password")
                            : $t("login.login_with_password")
                        }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>

            <p v-if="!forget_password && !registered" class="text-center mt-5">
              {{ $t("login.no_account") }}
              <v-btn
                small
                @click="
                  (registered = true),
                    (forget = false),
                    (forgetPassword = false),
                    (methodSelected = '')
                "
              >
                {{ $t("login.signup_now") }}
              </v-btn>
            </p>
          </v-col>

          <v-dialog
            v-model="dialog"
            max-height="300px"
            max-width="600px"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-progress-linear
                :value="loadingPercentage"
                color="teal"
                stream
              ></v-progress-linear>
            </v-card>

            <v-card>
              <a :href="$terminalads" target="_blank">
                <v-img src="media/terminalPopup.webp"></v-img>
              </a>
              <v-card-actions class="justify-end">
                <a :href="$terminalads" target="_blank">
                  <v-btn class="btn-update">
                    <v-icon class="icon-xl">mdi-information</v-icon>
                    {{ $t("login.more_info") }}
                  </v-btn>
                </a>
                <v-spacer> </v-spacer>
                <v-btn class="btn-cancel" @click="dialog = false">
                  <v-icon class="icon-xl">mdi-close-circle</v-icon>
                  {{ $t("login.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog
            v-model="dialogSignup"
            max-height="300px"
            max-width="600px"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-progress-linear
                :value="loadingPercentageSignup"
                color="teal"
                stream
              ></v-progress-linear>
            </v-card>

            <v-card>
              <a :href="$terminalads" target="_blank">
                <v-img src="media/signUpBanner.webp"></v-img>
              </a>
              <v-card-actions class="justify-end">
                <a :href="$terminalads" target="_blank">
                  <v-btn class="btn-update">
                    <v-icon class="icon-xl">mdi-information</v-icon>
                    {{ $t("login.more_info") }}
                  </v-btn>
                </a>
                <v-spacer> </v-spacer>
                <v-btn class="btn-cancel" @click="dialogSignup = false">
                  <v-icon class="icon-xl">mdi-close-circle</v-icon>
                  {{ $t("login.close") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import NumKeypad from "./numKeypad";
import { LOGIN, LOGOUT } from "@/core/services/store/auth.module";
import jwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import ForgetPassword from "./ForgetPassword";
import CustomPopup from "@/core/plugins/TitleRibbon/plugins/popup/customPopup";
import OTPReader from "otp-reader";
import i18nService from "@/core/services/i18n.service";
import { onChangeLanguage } from "@/i18n";
import TelInput from "@/components/TelInput.vue";
import RegisterForm from "./RegisterForm.vue";

export default {
  name: "login",
  components: {
    TelInput,
    CustomPopup,
    ForgetPassword,
    NumKeypad,
    RegisterForm,
  },
  data: () => ({
    // locales: i18nService.languages,
    code: null,
    verifyCode: null,
    popupLoading: false,
    invited: false,
    validateCode: false,
    forget: false,
    loadingGoogle: false,
    loadingPercentage: 100,
    loadingPercentageSignup: 100,
    dialog: false,
    dialogSignup: false,
    time: null,
    bannerTimer: null,
    numberCode: null,
    bannerTime: null,
    bannerTimerSignup: null,
    bannerTimeSignup: null,
    timer: null,
    methodSelected: "",
    forgetPassword: false,
    username: null,
    registerusername: "",
    phone: "",
    resend: false,
    email: "",
    password: "",
    remmember: false,
    demoLoading: false,
    loginpass: "",
    errors: {
      verify: {},
      register: {},
      passlogin: {},
    },
    loading: false,
    loadingotp: false,
    registered: false,
    verified: false,
    errorMessage: "",
    forget_password: false,
    forget_password_send: false,
    showErrorMessage: false,
    showSuccessMessage: false,
    formObject: {
      name: "",
      email: "",
      password: "",
    },
    timerSms: null,
    timeSms: null,
  }),
  mounted() {
    const origin = this.$route.query.call_back_origin;
    const hash = this.$route.query.call_back_hash;

    if (origin) {
      localStorage.setItem("redirect_origin", origin);
      localStorage.setItem("redirect_hash", hash);

      this.$router
        .replace({
          path: this.$route.path,
          query: {},
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    }

    this.$on("offline", () => {
      this.$toast.error(this.$t("login.no_internet")).length(5000);
    });

    window.addEventListener(
      "keyup",
      function (event) {
        if (event.keyCode === 13 && this.$route.name === "login") {
          if (this.methodSelected === "otp") {
            this.loginStep2(this.numberCode);
          } else if (!this.registered) {
            this.login();
          }
        }
      }.bind(this),
    );
  },
  beforeDestroy() {
    this.clearIntervalOnClose();
  },
  created() {
    if (
      this.$route.query.hasOwnProperty("inviteCode") &&
      !!this.$route.query["inviteCode"]
    ) {
      localStorage.setItem("inviteCode", this.$route.query["inviteCode"]);
      this.invited = true;
      this.registered = true;
    }
    this.$vuetify.rtl = true;
    this.$vuetify.theme.dark = this.getCookie("theme", "false") === "true";
    this.$root.$on("Step2", this.loginStep2);
  },
  computed: {
    locales() {
      return i18nService.languages.map((lang) => {
        const translatedName = this.$t(`language.lang.${lang.lang}`);
        // Fallback: if translation missing, use native name or lang code
        const subtitle =
          translatedName !== `language.lang.${lang.lang}`
            ? translatedName
            : lang.name;
        return {
          ...lang,
          subtitle: subtitle,
        };
      });
    },
    rules() {
      return {
        required: (value) => !!value || this.$t("login.required_field"),
        min: (v) => v.length >= 8 || this.$t("login.min_8_char"),
      };
    },
    // defaultCountry() {
    //   const map = {
    //     fa: "IR",
    //     ar: "IQ",
    //     ar_ae: "AE",
    //     ar_iq: "IQ",
    //     en_US: "US",
    //     en_GB: "GB",
    //     en: "US",
    //     fr: "FR",
    //     de: "DE",
    //     hy: "AM",
    //     ru: "RU",
    //     tr: "TR",
    //     zh_CN: "CN",
    //     zh_TW: "TW",
    //   };
    //   return map[this.$i18n.locale] || "IR";
    // },
    backgroundImage() {
      return this.ir(process.env.BASE_URL) + "media/svg/auth-bg.svg";
    },
    currentLocale() {
      const fn = (lang) => {
        return this.locales.find((x) => x.lang === lang);
      };
      return fn(this.$i18n.locale) ?? fn("en_US");
    },
  },
  watch: {
    registered(val) {
      if (val) {
        this.$toast.info(this.$t("login.registration_nid_required_notice"), {
          position: "top-center",
          timeout: 10000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: true,
        });
      }
    },
  },
  methods: {
    onValidate({ number, valid, country }) {},

    onInput(number) {
      this.username = number || "";
    },
    onChangeLanguage,
    goToGoogle() {
      this.loadingGoogle = true;
      return window.location.replace(`${this.$sarveLand}/api/redirect/google`);
    },
    checkLogin() {
      if (jwtService.getToken()) {
        window.history.pushState("home", "Title", "/#/dashboard");
        window.location.reload();
      }
    },
    verify() {
      console.log(this.uername, "username");
      if (!this.username) {
        return this.$toast.error(this.$t("login.no_phone_entered"));
      }
      this.username = this.username.replace("+", "");
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }
      console.log(this.username, "username after format");
      const vm = this;
      this.loadingotp = true;
      this.forget = false;
      this.forgetPassword = false;
      this.errors.verify = {};

      this.$toast.success(this.$t("login.otp_sent_successfully"));
      this.methodSelected = "otp";
      if (this.timerSms) return;
      this.timeSms = 30;
      this.timerSms = setInterval(() => {
        this.timeSms--;
        if (this.timeSms === 0) {
          clearInterval(this.timerSms);
          this.timerSms = null;
        }
      }, 1000);

      this.loadingotp = false;
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }

      this.generateRecaptchaToken("login")
        .then((token) => {
          this.requestApiPost("auth/user-verify", {
            username: this.english(this.username),
            token: token,
            resend: this.resend,
          })
            .then(({ data }) => {
              this.setOTPReader();
            })
            .catch(({ response }) => {
              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0
              ) {
                this.forget = false;
                this.forgetPassword = false;
                this.$toast.error(this.$t("login.please_register_first"));
                this.methodSelected = "";
                this.registered = true;
                this.methodSelected = "";
                this.phone = this.english(this.username);
                this.errors.verify = response.data.errors;
              }
              if (response.status === 429) {
                if (this.timerSms) return;
                this.timeSms = response.headers["retry-after"];
                this.timerSms = setInterval(() => {
                  this.timeSms--;
                  if (this.timeSms === 0) {
                    clearInterval(this.timerSms);
                    this.timerSms = null;
                  }
                }, 1000);
                return this.$toast.error(this.$t("login.wait_3_min"));
              }
            })
            .finally(() => {});
        })
        .catch((err) => {
          this.loadingotp = false;
        });
    },
    setOTPReader() {
      const otpReader = new OTPReader();

      otpReader
        .getCode()
        .then((code) => {
          this.numberCode = code;

          this.$nextTick(() => {
            this.loginStep2(code);
          });
        })
        .catch((err) => {
          console.log("failed to get otp: ", err);
        });
    },
    yektanet() {
      yektanet("event", "1b2fa01c-92eb-4558-913a-02a8fcf91485");
    },
    login() {
      console.log("login called");
      this.loading = true;
      if (!!this.username && this.username.startsWith("+")) {
        this.username = this.username.replace("+", "").trim();
      }
      if (
        this.username.trim().startsWith("9") &&
        this.username.trim().length === 10
      ) {
        this.username = `0${this.username.trim()}`;
      }
      this.generateRecaptchaToken("login")
        .then((token) => {
          this.requestApiPost("auth/signIn", {
            via: "pass",
            username: this.english(this.username),
            password: this.loginpass,
            token: token,
          })
            .then(({ data }) => {
              this.$toast.success(this.$t("login.login_successful"));
              this.user = data.data;
              this.registered = false;
              this.$store.dispatch(LOGIN, data.data.user);

              if (
                Object.hasOwn(this.$route?.query, "call_back_origin") &&
                Object.hasOwn(this.$route?.query, "call_back_hash")
              ) {
                window.location.href =
                  this.$route.query["call_back_origin"] +
                  `/?token=${data.data?.user?.token}#` +
                  this.$route.query["call_back_hash"];
              } else {
                this.setFirstLogin();
                this.$router.replace("/dashboard");
              }
            })
            .catch(({ response }) => {
              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0 &&
                response.data.errors.username
              ) {
                this.forget = false;
                this.forgetPassword = false;
                this.$toast.error(this.$t("login.please_register_first"));
                this.methodSelected = "";
                this.registered = true;
                this.methodSelected = "";
                this.phone = this.english(this.username);
                this.errors.verify = response.data.errors;
              }
              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0
              )
                this.errors.verify = response.data.errors;
              if (response.data.errors.smsVerified)
                this.$toast.error(response.data.errors.smsVerified[0]);
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch((err) => {
          this.loading = false;
          this.$toast.error(this.$t("login.internet_connection_error"));
        });
    },
    loginStep2(key) {
      if (this.forgetPassword) {
        return this.sendCode(key);
      }
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }
      this.loading = true;
      this.generateRecaptchaToken("login")
        .then((token) => {
          this.requestApiPost("auth/signIn", {
            via: "otp",
            username: this.english(this.username),
            code: this.english(key),
            token: token,
          })
            .then(({ data }) => {
              this.$toast.success(this.$t("login.login_successful"));
              this.user = data.data;
              this.registered = false;
              this.$store.dispatch(LOGOUT);
              this.$store.dispatch(LOGIN, data.data.user);
              this.setFirstLogin();
              this.$router.push({ name: "home" });
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0
              )
                this.errors.passlogin = response.data.errors;
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch((err) => {
          this.$toast.error(this.$t("login.internet_connection_error"));
          this.loading = false;
        });
    },
    register(formData) {
      this.loading = true;
      this.username = formData.phone;
      const params = new URLSearchParams();

      if (formData.parentPhone) {
        params.append("parentPhone", formData.parentPhone);
      }

      if (!!localStorage.getItem("inviteCode")) {
        params.append("parentLink", localStorage.getItem("inviteCode"));
      }

      params.append("name", formData.name);
      params.append("lastName", formData.lastName);
      params.append("phone", formData.phone);
      params.append("nid", formData.nid);
      params.append(
        "call_back_origin",
        this.$route?.query?.call_back_origin ??
          localStorage.getItem("redirect_origin"),
      );
      params.append("lang", this.$i18n.locale);

      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }
      this.loadingotp = true;
      this.generateRecaptchaToken("login")
        .then((token) => {
          params.append("token", token);
          this.requestApiPostLogin("auth/register", params, config)
            .then(({ data }) => {
              this.user = data.data;
              this.$toast.success(
                this.$t("login.otp_sent_successfully_register"),
              );
              this.forget = false;
              this.forgetPassword = false;
              this.registered = false;
              this.methodSelected = "otp";
              if (this.timerSms) return;
              this.timeSms = 60;
              this.timerSms = setInterval(() => {
                this.timeSms--;
                if (this.timeSms === 0) {
                  clearInterval(this.timerSms);
                  this.timerSms = null;
                }
              }, 1000);
              yektanet("register", "a6590854-acd4-4b29-98dd-ac9295ff9b77");
            })
            .catch(({ response }) => {
              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0
              )
                this.errors.register = response.data.errors;

              if (
                response.data != null &&
                this.objectLength(response.data.errors) > 0
              )
                this.errors.verify = response.data.errors;

              if (response.status === 429) {
                if (this.timerSms) return;
                this.timeSms = response.headers["retry-after"];
                this.timerSms = setInterval(() => {
                  this.timeSms--;
                  if (this.timeSms === 0) {
                    clearInterval(this.timerSms);
                    this.timerSms = null;
                  }
                }, 1000);
                return this.$toast.error(this.$t("login.wait_3_min"));
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch((err) => {
          this.$toast.error(this.$t("login.internet_connection_error"));
          this.loading = false;
        });
    },
    forgetPass() {
      this.loading = true;
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }

      this.generateRecaptchaToken("login")
        .then((token) => {
          this.requestApiPost(`forget-password`, {
            username: this.english(this.username),
            token: token,
          })
            .then((response) => {
              this.loading = false;
              this.$toast.success(response.data.message);
              this.forgetPassword = true;
              this.methodSelected = "otp";
              if (this.timer) return;
              this.time = 60;
              this.timer = setInterval(
                function () {
                  this.time--;
                  if (this.time === 0) {
                    clearInterval(this.timer);
                    this.timer = null;
                  }
                }.bind(this),
                1000,
              );
            })
            .catch(({ response }) => {
              this.loading = false;
              if (response.status === 422)
                return this.$toast.error(response.data.errors.username[0]);
              if (response.status === 429) {
                if (this.timer) return;
                this.time = response.headers["retry-after"];
                this.timer = setInterval(
                  function () {
                    this.time--;
                    if (this.time === 0) {
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }.bind(this),
                  1000,
                );
                return this.$toast.error(this.$t("login.wait_3_min"));
              }
            });
        })
        .catch((err) => {
          this.$toast.error(this.$t("login.error"));
        });
    },
    sendCode(key) {
      this.code = key;
      if (
        this.username.trim().length === 10 &&
        this.username.trim().startsWith("9")
      ) {
        this.username = `0${this.username.trim()}`;
      }

      this.generateRecaptchaToken("login")
        .then((token) => {
          this.requestApiPost(`reset-password`, {
            code: this.english(key),
            username: this.english(this.username),
            token: token,
          })
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.methodSelected = "";
              this.forget = true;
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        })
        .catch((err) => {
          this.$toast.error(this.$t("login.error"));
        });
    },
    wrongNumber() {
      let columns = document.getElementById("keypad-column-holder");

      for (let i = 0; i < columns.children.length; i++) {
        if (columns.children[i].classList.contains("put-wrong-class")) {
          columns.children[i].classList.remove("put-wrong-class");
        }
        setTimeout(() => {
          columns.children[i].classList.add("put-wrong-class");
        }, 200);
      }
    },
    editNumber() {
      this.clearIntervalOnClose();
      this.step1 = false;
      this.resend = false;
    },
    clearIntervalOnClose() {
      clearInterval(this.myfunc);
      this.myfunc = undefined;
    },
  },
};
</script>

<style scoped>
.v-dialog {
  position: absolute;
  bottom: 0;
  right: 0;
}

.my-custom-dialog {
  align-self: flex-end;
}

@keyframes jump {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(10px);
  }
  100% {
    transform: translateY(0px);
  }
}

#jumpingBtn {
  animation: jump 1s ease infinite;
}

.loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(45deg, #0f8, #08f);
  z-index: 0;
  filter: hue-rotate(360deg);
  animation: hue 40000ms infinite linear;
}

@keyframes hue {
  0% {
    filter: hue-rotate(0deg);
  }
  100% {
    filter: hue-rotate(360deg);
  }
}

.auth-box {
  background-image: url("/media/svg/auth-bg.svg") !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  background-position: center !important;
}

@media (min-width: 601px) {
  .login-box {
    margin: 0 auto;
    width: 450px;
  }
}

@media (max-width: 601px) {
  .login-box {
    border: none !important;
    background: none !important;
    box-shadow: none !important;
  }

  hr {
    display: none !important;
  }

  .auth-img-holder {
    transform: translateY(-80%);
    margin-bottom: -32px;
  }
}

@keyframes wrong-code-anm {
  0% {
    opacity: 100%;
    transform: scale(1);
  }
  50% {
    opacity: 50%;
    transform: scale(0.4);
  }
  100% {
    opacity: 100%;
    transform: scale(1);
  }
}
</style>
